import http from "../../../request";

export default {
  home: async (context) => {
    let response = await http.get("home", localStorage.getItem("lang"));
    context.commit("setHome", response);
  },
};
